
import { defineComponent } from "vue";
import { Item } from "@/types";
import { ItemDatabase } from "@/state/Gacha";

export default defineComponent({
  props: {
    centerItemId: {
      type: String,
      required: true,
    },
    sideItemIds: {
      type: Object as () => string[],
      required: true,
    },
    accentColor: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    centerImageStyle(): { [key: string]: string } {
      return {
        "--center-img-src": `url(../../assets/images/drops/${this.centerItem.id}.webp)`,
      };
    },
    centerItem(): Item {
      return ItemDatabase[this.centerItemId];
    },
    sideItems(): Item[] {
      return this.sideItemIds.map((i) => ItemDatabase[i]);
    },
  },
});
